import { Controller } from "stimulus";

// Keeps an episode's season select and number field in step with what auto-save did: a season picked
// for a numberless episode shows the number the server just gave it, and a season the server refused
// goes back to the saved one. Auto-save only fires after season-confirm lets a change through, so a
// cancelled confirm never reaches here. The number is only ever the server's, never worked out here.
export default class extends Controller {
  static targets = ["number"];

  connect() {
    this.remembered = this.select?.value;
  }

  saved(event) {
    if (event.target !== this.select) return;

    this.remembered = this.select.value;
    const data = event.detail?.data;
    // Only a number the server just handed out is shown; one the creator typed or kept is left alone.
    if (data?.episode_number_assigned && this.hasNumberTarget) this.numberTarget.value = data.episode_number;
  }

  failed(event) {
    if (event.target !== this.select) return;

    this.select.value = this.remembered;
    const confirm = this.select.closest("[data-controller~='season-confirm']");
    const controller = confirm && this.application.getControllerForElementAndIdentifier(confirm, "season-confirm");
    if (controller) controller.previous = this.remembered;
    // Tells auto-save the change is gone, so its pending timer can't send the old value as a new save.
    event.preventDefault();
  }

  get select() {
    return this.element.querySelector("select[name$='[season_id]']");
  }
}
